import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Form, Formik } from "formik";
import { useSelector } from "react-redux";
import FormikActions from "../../../../../commons/formik/FormikActions";
import FormikAutocomplete from "../../../../../commons/formik/FormikAutocomplete";
import { StyledResolucion } from "../../../../../styled/Prevencion";
import { elementosDeProteccionValidation } from "../puestosValidations";

const ElementosDeProteccionForm = ({ open, handleClose, handleSubmit, initialValues, selectedOptions }) => {
  const elementosDeProteccion = useSelector((state) => state.resolucion.elementosProteccionPersonal.data)

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        Agregar Elemento de Protección
      </DialogTitle>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => handleSubmit(values)}
        validationSchema={elementosDeProteccionValidation(selectedOptions)}
      >
        {() => (
          <Form>
            <DialogContent>
              <Grid container>
                <StyledResolucion.DialogGridItem item xs={12}>
                  <FormikAutocomplete
                    name="idElementoDeProteccion"
                    label="Elementos de Protección"
                    options={elementosDeProteccion}

                    fullWidth
                  //getOptions={() => dispatch(getElementosDeProteccion())}
                  />
                </StyledResolucion.DialogGridItem>
              </Grid>
            </DialogContent>

            <DialogActions>
              <FormikActions handleCancel={handleClose} />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default ElementosDeProteccionForm;
